import React, { useState, useRef, useEffect, useCallback } from 'react';
import Dialog from 'components/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import io from 'socket.io-client';
import Button from '@material-ui/core/Button';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import Avatar from '@mui/material/Avatar';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PersonIcon from '@mui/icons-material/Person';
import CircularProgress from '@mui/material/CircularProgress';
import { getService } from 'reducers/service';

// Define styles for the chat interface
const styles = `
  .mic-container {
    position: relative;
    display: inline-block;
  }
  .wave-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background: rgba(255, 0, 0, 0.5);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(1);
    animation: wave 1.5s infinite ease-out;
    pointer-events: none;
  }
  @keyframes wave {
    0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
    100% { transform: translate(-50%, -50%) scale(1.5); opacity: 0; }
  }
  .chat-container {
    display: flex;
    flex-direction: column;
    height: 300px;
    overflow-y: auto;
    padding: 10px;
    border-radius: 4px;
    scroll-behavior: smooth;
  }
  .message {
    display: flex;
    margin-bottom: 10px;
    max-width: 80%;
    animation: fadeIn 0.3s ease-in-out;
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .user-message {
    align-self: flex-end;
    flex-direction: row-reverse;
  }
  .ai-message {
    align-self: flex-start;
  }
  .message-content {
    padding: 8px 12px;
    border-radius: 18px;
    margin: 0 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }
  .user-message .message-content {
    background-color: #0084ff;
  }
  .ai-message .message-content {
    background-color: #e4e6eb;
    color: black;
  }
  .ai-message .message-content div {
    line-height: 1.5;
  }
  .ai-message .message-content strong {
    font-weight: 600;
    color: #2c3e50;
  }
  .ai-message .message-content br {
    display: block;
    margin: 4px 0;
  }
  .avatar {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .typing-indicator {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
  .typing-dot {
    width: 8px;
    height: 8px;
    margin: 0 1px;
    background-color: #999;
    border-radius: 50%;
    animation: typing-animation 1.4s infinite ease-in-out;
  }
  .typing-dot:nth-child(1) { animation-delay: 0s; }
  .typing-dot:nth-child(2) { animation-delay: 0.2s; }
  .typing-dot:nth-child(3) { animation-delay: 0.4s; }
  @keyframes typing-animation {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-5px); }
  }
  .connection-status {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .status-connected {
    background-color: #4caf50;
  }
  .status-connecting {
    background-color: #ff9800;
    animation: pulse 1.5s infinite;
  }
  .status-disconnected {
    background-color: #f44336;
  }
  @keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
  }
  .extracted-data-indicator {
    font-size: 12px;
    color: #4caf50;
    margin-top: 5px;
    animation: fadeIn 0.5s ease-in-out;
  }
  .modal-opening-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #4caf50, #45a049);
    color: white;
    border-radius: 20px;
    margin: 16px auto;
    max-width: 300px;
    animation: slideInUp 0.5s ease-out;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  }
  .modal-opening-indicator .progress-bar {
    width: 100%;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    overflow: hidden;
  }
  .modal-opening-indicator .progress-fill {
    height: 100%;
    background: white;
    border-radius: 2px;
    animation: progressFill 5s linear forwards;
  }
  @keyframes progressFill {
    from { width: 0%; }
    to { width: 100%; }
  }
  .modal-opening-indicator .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  .listening-animation {
    display: inline-block;
    animation: listeningMove 2s ease-in-out infinite;
    position: relative;
  }
  @keyframes listeningMove {
    0% {
      
      opacity: 0.7;
    }
    25% {
      
      opacity: 1;
    }
    50% {
      
      opacity: 0.8;
    }
    75% {
     
      opacity: 1;
    }
    100% {
 
      opacity: 0.7;
    }
  }
  .listening-dots {
    display: inline-block;
    margin-left: 4px;
  }

  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  @keyframes pulse {
    0%, 100% { opacity: 0.7; }
    50% { opacity: 1; }
  }
  .voice-modal-no-backdrop .MuiBackdrop-root {
    display: none !important;
  }
  .voice-modal-no-backdrop {
    z-index: 9999 !important;
    pointer-events: none !important;
  }
  .voice-modal-no-backdrop .MuiDialog-container {
    pointer-events: none !important;
  }
  .voice-modal-no-backdrop .MuiPaper-root {
    pointer-events: auto !important;
  }
`;

// Debounce function to prevent too frequent UI updates
const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

const VoiceInputModal = ({
  onClose,
  props,
  aiResponse,
  setAiResponse,
  onOpenAddEvent,
  addEventModalOpen,
  setLocation,
}) => {
  const [transcript, setTranscript] = useState('');
  const [fullTranscript, setFullTranscript] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [isFirstWordLoading, setIsFirstWordLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    {
      type: 'ai',
      content:
        "Hello! I'm your AI assistant for creating events. I can create events immediately with simple commands:<br/><br/>" +
        '<strong>Instant Event Creation - Just say:</strong><br/>' +
        "• 'Create burglary at 123 Main Street'<br/>" +
        "• 'Report robbery at Walmart'<br/>" +
        "• 'Begin accident on Highway 101'<br/><br/>" +
        "<strong>Need more details?</strong> I'll stay active after creating the event so you can add caller info, notes, etc.<br/><br/>" +
        'Click the microphone and speak your command!',
    },
  ]);

  const [isAiTyping, setIsAiTyping] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('disconnected');
  const [extractedFields, setExtractedFields] = useState([]);
  const [socketRetryCount, setSocketRetryCount] = useState(0);
  const [isSocketError, setIsSocketError] = useState(false);
  const [hasScheduledEventOpen, setHasScheduledEventOpen] = useState(false);
  const [countdownSeconds, setCountdownSeconds] = useState(5);
  const [eventModalOpened, setEventModalOpened] = useState(false);

  const mediaRecorderRef = useRef(null);
  const eventOpenTimeoutRef = useRef(null);
  const socketRef = useRef(null);
  const chatContainerRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);

  // Create debounced version of addAiMessage to prevent UI jank
  const addAiMessageDebounced = useRef(
    debounce((message) => {
      if (message.trim()) {
        setChatMessages((prev) => [...prev, { type: 'ai', content: message }]);
      }
    }, 100)
  ).current;

  // Address search functionality
  const findAddress = async (searchTerm) => {
    if (!searchTerm) return null;
    try {
      const service = getService('address-lookup');
      let addresses = await service.find({
        query: { FullAddressText: searchTerm, ShowInEventLookup: false },
      });

      if (addresses.length === 1) {
        const address = await onAddressSelect(addresses[0]);

        setLocation(address);
      }

      return addresses || [];
    } catch (error) {
      console.error('Error searching addresses:', error);
      return [];
    }
  };

  const getAddress = async (ptsAddressID) => {
    if (!ptsAddressID) return null;
    try {
      const service = getService('address-lookup');
      const address = await service.get(ptsAddressID);

      return address;
    } catch (error) {
      console.error('Error getting address details:', error);
      return null;
    }
  };

  const onAddressSelect = async (address) => {
    if (!address) return;

    try {
      const addressDetails = await getAddress(address.ptsAddressID);
      const finalAddress = { ...address, ...addressDetails };

      // Here you can add any additional logic needed when an address is selected
      // For example, you might want to update some state or call a callback

      return finalAddress;
    } catch (error) {
      console.error('Error processing selected address:', error);
      return null;
    }
  };

  // Helper function to create current payload data
  const getCurrentPayloadData = useCallback(() => {
    return {
      event: {
        EventTypes: props?.dictionary?.CallTypes,
        EventSubTypes: props?.dictionary?.CallSubTypes,
        CallMethods: props?.dictionary?.CallMethods,
      },
      streetTypes: props?.dictionary?.StreetTypes,
      prevData: aiResponse,
      addEventModalOpen: addEventModalOpen,
    };
  }, [props?.dictionary, aiResponse, addEventModalOpen]);

  useEffect(() => {
    // Scroll to bottom when messages change
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  // Handle aiResponse updates and trigger AddEvent modal with 5-second delay
  useEffect(() => {
    // Check if user wants to close the assistant
    if (aiResponse?.shouldCloseAssistant) {
      stopListening(false); // Don't show the "stopped listening" message
      onClose(); // Close the voice modal
      return;
    }

    // Check if event should end and schedule AddEvent modal (only once)
    if (aiResponse?.shouldEventModalOpen && !hasScheduledEventOpen && !eventModalOpened) {
      setHasScheduledEventOpen(true);
      setCountdownSeconds(5);

      // Start countdown timer
      const countdownInterval = setInterval(() => {
        setCountdownSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      eventOpenTimeoutRef.current = setTimeout(() => {
        clearInterval(countdownInterval);
        onOpenAddEvent();
        setEventModalOpened(true);
        eventOpenTimeoutRef.current = null;

        // Hide the indicators after modal opens
        setTimeout(() => {
          setHasScheduledEventOpen(false);
          setCountdownSeconds(5);
        }, 1000);
      }, 5000);
    }
  }, [aiResponse, onOpenAddEvent, hasScheduledEventOpen, eventModalOpened, onClose]);

  // Separate effect for sending payload data to avoid unnecessary re-renders
  useEffect(() => {
    if (socketRef.current && socketRef.current.connected && aiResponse) {
      const updatedPayload = getCurrentPayloadData();

      updatedPayload.message =
        chatMessages[chatMessages.length - 1]?.type === 'ai'
          ? chatMessages[chatMessages.length - 1].content
          : '';

      socketRef.current.emit('payloadData', updatedPayload);
    }
  }, [aiResponse, getCurrentPayloadData]);

  useEffect(() => {
    return () => {
      stopListening();
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (eventOpenTimeoutRef.current) {
        clearTimeout(eventOpenTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // Update fullTranscript whenever transcript changes
    if (transcript.trim()) {
      setFullTranscript((prev) => {
        const newTranscript = prev ? `${prev} ${transcript}` : transcript;
        return newTranscript;
      });
    }
  }, [transcript]);

  // Add user message to chat
  const addUserMessage = useCallback((message) => {
    if (message.trim()) {
      setChatMessages((prev) => [...prev, { type: 'user', content: message }]);
      setTranscript('');
    }
  }, []);

  // Add AI message to chat
  const addAiMessage = useCallback(
    (message) => {
      addAiMessageDebounced(message);
    },
    [addAiMessageDebounced]
  );

  // Stop listening function - defined first to avoid circular dependencies
  const stopListening = useCallback(
    (showMessage = true) => {
      setIsFirstWordLoading(false);

      if (transcript.trim()) {
        addUserMessage(transcript);
      }

      setTranscript('');
      setFullTranscript('');
      setIsAiTyping(false);
      setExtractedFields([]);
      setHasScheduledEventOpen(false);
      setCountdownSeconds(5);
      setEventModalOpened(false);

      // Clear any pending event open timeout
      if (eventOpenTimeoutRef.current) {
        clearTimeout(eventOpenTimeoutRef.current);
        eventOpenTimeoutRef.current = null;
      }

      if (mediaRecorderRef.current && isListening) {
        mediaRecorderRef.current.stop();
        mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
        setIsListening(false);
        if (showMessage) {
          addAiMessage("I've stopped listening. Click the microphone to speak again.");
        }
      }

      if (socketRef.current) {
        socketRef.current.emit('clearTranscript');
        socketRef.current.disconnect();
        socketRef.current = null;
        setConnectionStatus('disconnected');
      }
    },
    [transcript, isListening, addUserMessage, addAiMessage]
  );

  // Handle socket errors with retry logic
  const handleSocketError = useCallback(
    (errorMessage) => {
      // Prevent multiple error handling calls
      if (isSocketError) return;

      setIsSocketError(true);

      if (socketRetryCount < 3) {
        setSocketRetryCount((prev) => prev + 1);
        addAiMessage(errorMessage);

        reconnectTimeoutRef.current = setTimeout(() => {
          setupSocketConnection();
        }, 2000);
      } else {
        addAiMessage("I'm having trouble connecting to the voice service. Please try again later.");
        stopListening(false); // Don't show the "stopped listening" message
      }
    },
    [socketRetryCount, addAiMessage, stopListening, isSocketError]
  );

  // useEffect(() => {
  //   if (aiResponse?.location) {
  //     findAddress(aiResponse.location);
  //   }
  // }, [aiResponse?.location]);

  // Setup socket event listeners
  const setupSocketEventListeners = useCallback(() => {
    if (!socketRef.current) return;

    // Set up listeners
    socketRef.current.on('transcription', (data) => {
      if (data.transcript) {
        setIsFirstWordLoading(false);
        setTranscript(data.transcript);

        if (data.isFinal) {
          addUserMessage(data.transcript);
          setIsAiTyping(true);
        }
      }

      if (data.extractedFormData) {
        setAiResponse(data.extractedFormData);
      }
    });

    socketRef.current.on('formData', (data) => {
      if (data.extractedFormData) {
        setAiResponse(data.extractedFormData);

        const fields = Object.keys(data.extractedFormData).filter(
          (key) => key !== 'error' && data.extractedFormData[key]
        );

        setExtractedFields(fields);
      }

      if (data?.message) {
        setIsAiTyping(false);
        addAiMessage(data.message);
      }

      if (data?.extractedFormData?.location) {
        findAddress(data.extractedFormData.location);
        // findAddress('amtoli byron');
      }

      if (data.error) {
        setTimeout(() => {
          setIsAiTyping(false);
          addAiMessage('Sorry, I have got some error. Please try again.');
        }, 800);

        stopListening();
      }
    });

    socketRef.current.on('error', () => {
      addAiMessage('An error occurred with the voice service.');
      handleSocketError('An error occurred with the voice service.');
    });
  }, [addUserMessage, addAiMessage, handleSocketError, stopListening]);

  // Setup socket connection with retry logic
  const setupSocketConnection = useCallback(async () => {
    try {
      setConnectionStatus('connecting');

      // Close existing socket if any
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }

      socketRef.current = io(process.env.REACT_APP_AI_SERVICE_URL, {
        transports: ['websocket', 'polling'],
        perMessageDeflate: false,
        timeout: 10000,
        requestTimeout: 10000,
        reconnection: true,
        reconnectionAttempts: 3,
        reconnectionDelay: 1000,
        pingTimeout: 5000,
        pingInterval: 2000,
      });

      // Set up connection event handlers
      socketRef.current.on('connect', () => {
        setConnectionStatus('connected');
        setSocketRetryCount(0);
        setIsSocketError(false);

        // Setup event listeners after successful connection
        setupSocketEventListeners();

        // Send initial payload data after connection
        const initialPayload = getCurrentPayloadData();
        socketRef.current.emit('payloadData', initialPayload);
      });

      socketRef.current.on('connect_error', () => {
        handleSocketError('Connection error. Retrying...');
      });

      socketRef.current.on('disconnect', (reason) => {
        setConnectionStatus('disconnected');

        if (reason === 'transport close' || reason === 'ping timeout') {
          handleSocketError('Connection lost due to network issues. Attempting to reconnect...');
        }

        if (isListening) {
          handleSocketError('Connection lost. Attempting to reconnect...');
        }
      });

      return true;
    } catch (err) {
      handleSocketError('Failed to connect to the voice service.');
      return false;
    }
  }, [isListening, getCurrentPayloadData, handleSocketError, setupSocketEventListeners]);

  // Start audio recording and processing
  const startAudioRecording = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
          sampleRate: 16000,
        },
      });

      mediaRecorderRef.current = new MediaRecorder(stream, {
        mimeType: 'audio/webm',
        audioBitsPerSecond: 16000,
      });

      let lastTransmissionTime = Date.now();
      let transmissionErrors = 0;

      mediaRecorderRef.current.ondataavailable = async (e) => {
        if (socketRef.current && socketRef.current.connected) {
          try {
            if (e.data.size === 0) {
              return;
            }

            const currentTime = Date.now();
            if (currentTime - lastTransmissionTime > 5000) {
              console.warn('Large gap in audio transmission:', currentTime - lastTransmissionTime);
            }
            lastTransmissionTime = currentTime;

            const currentPayload = getCurrentPayloadData();

            socketRef.current.emit(
              'voiceData',
              {
                vdata: e.data,
                transcript: fullTranscript,
                payloadData: currentPayload,
              },
              (error) => {
                if (error) {
                  console.error('Error sending voice data:', error);
                  transmissionErrors++;

                  if (transmissionErrors > 5) {
                    stopListening();
                    addAiMessage("I'm having trouble sending the audio data. Please try again.");
                  }
                } else {
                  transmissionErrors = 0;
                }
              }
            );
          } catch (err) {
            console.error('Error processing audio chunk:', err);
            transmissionErrors++;
          }
        } else {
          // Don't call stopListening here as it can cause infinite loops
          // Just add the message and let the error handling take care of it
          addAiMessage('Lost connection to the server. Please try again.');
          // Reset the listening state without full cleanup
          setIsListening(false);
          if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
          }
        }
      };

      mediaRecorderRef.current.onerror = () => {
        stopListening();
        addAiMessage('There was an error with the audio recording. Please try again.');
      };

      mediaRecorderRef.current.start(250);
      setIsListening(true);
      addAiMessage("I'm listening. Please speak clearly...");

      return true;
    } catch (err) {
      addAiMessage('Could not access microphone. Please check permissions.');
      return false;
    }
  }, [fullTranscript, getCurrentPayloadData, addAiMessage, stopListening]);

  const startListening = useCallback(async () => {
    try {
      setTranscript('');
      setAiResponse(null);
      setIsFirstWordLoading(true);
      setExtractedFields([]);
      setHasScheduledEventOpen(false);
      setCountdownSeconds(5);
      setEventModalOpened(false);

      const socketConnected = await setupSocketConnection();

      if (!socketConnected) {
        setIsFirstWordLoading(false);
        return;
      }

      const recordingStarted = await startAudioRecording();

      if (!recordingStarted) {
        setIsFirstWordLoading(false);
        stopListening();
      }
    } catch (err) {
      setIsFirstWordLoading(false);
      addAiMessage('An unexpected error occurred. Please try again.');
      stopListening();
    }
  }, [setupSocketConnection, startAudioRecording, addAiMessage, stopListening]);

  // Render message content with address parsing
  const renderMessageContent = useCallback((content) => {
    if (!content) return null;

    const text = content;
    const lower = text.toLowerCase();
    const startIndex = lower.indexOf('address 1:');
    const hasHtml = /<[^>]*>/.test(text);

    if (startIndex === -1) {
      return hasHtml ? <div dangerouslySetInnerHTML={{ __html: text }} /> : text;
    }

    const listPart = text.slice(startIndex);
    const beforePart = text.slice(0, startIndex);
    const regex = /address\s+(\d+):\s*([^]*?)(?=(?:\s+address\s+\d+:|$))/gi;
    const parsed = [];
    let match;

    while ((match = regex.exec(listPart)) !== null) {
      parsed.push({
        displayIndex: parseInt(match[1], 10),
        FullAddressText: (match[2] || '').trim(),
      });
    }

    if (!parsed.length) {
      return hasHtml ? <div dangerouslySetInnerHTML={{ __html: text }} /> : text;
    }

    return (
      <div>
        {beforePart && (
          <div
            style={{ marginBottom: 6 }}
            dangerouslySetInnerHTML={{ __html: beforePart.trim() }}
          />
        )}
      </div>
    );
  }, []);

  return (
    <>
      <style>{styles}</style>
      <Dialog
        style={{ padding: '0px', zIndex: 9999 }}
        toolbar
        onClose={onClose}
        title="Voice Assistant"
        maxWidth="md"
        className="voice-modal-no-backdrop">
        <DialogContent
          style={{
            width: '400px',
            padding: '0px',
            position: 'relative',
          }}>
          {/* Connection status indicator */}
          <div className="connection-status">
            <div className={`status-indicator status-${connectionStatus}`}></div>
            <span>
              {connectionStatus === 'connected'
                ? 'Connected'
                : connectionStatus === 'connecting'
                ? 'Connecting...'
                : 'Disconnected'}
            </span>
          </div>

          {/* Chat container */}
          <div className="chat-container" ref={chatContainerRef}>
            {chatMessages.map((message, index) => {
              const isUser = message.type === 'user';
              if (typeof message?.content === 'string')
                return (
                  <div key={index} className={`message ${isUser ? 'user-message' : 'ai-message'}`}>
                    <div className="avatar">
                      {isUser ? (
                        <Avatar sx={{ bgcolor: '#0084ff' }}>
                          <PersonIcon />
                        </Avatar>
                      ) : (
                        <Avatar sx={{ bgcolor: '#e4e6eb', color: '#000' }}>
                          <SmartToyIcon />
                        </Avatar>
                      )}
                    </div>

                    <div className="message-content">{renderMessageContent(message.content)}</div>
                  </div>
                );
              return null;
            })}

            {/* Live transcript display */}
            {isListening && transcript && !isFirstWordLoading && (
              <div className="message user-message">
                <div className="avatar">
                  <Avatar sx={{ bgcolor: '#0084ff' }}>
                    <PersonIcon />
                  </Avatar>
                </div>
                <div className="message-content" style={{ opacity: 0.7 }}>
                  {transcript}
                </div>
              </div>
            )}

            {/* AI typing indicator */}
            {isAiTyping && (
              <div className="message ai-message">
                <div className="avatar">
                  <Avatar sx={{ bgcolor: '#e4e6eb', color: '#000' }}>
                    <SmartToyIcon />
                  </Avatar>
                </div>
                <div className="typing-indicator">
                  <div className="typing-dot"></div>
                  <div className="typing-dot"></div>
                  <div className="typing-dot"></div>
                </div>
              </div>
            )}

            {/* Loading indicator for first word */}
            {!isAiTyping && isListening && !hasScheduledEventOpen && (
              <div className="message user-message">
                <div className="avatar">
                  <Avatar sx={{ bgcolor: '#0084ff' }}>
                    <PersonIcon />
                  </Avatar>
                </div>
                <div className="message-content" style={{ opacity: 0.7 }}>
                  <span className="listening-animation">Listening ...</span>
                  <span className="listening-dots"></span>
                </div>
              </div>
            )}

            {/* Extracted data indicator */}
            {extractedFields.length > 0 && (
              <div className="extracted-data-indicator">
                ✓ {extractedFields.length} field{extractedFields.length !== 1 ? 's' : ''} captured
              </div>
            )}

            {/* Modal opening indicator - only show when countdown is active AND modal not yet opened */}
            {hasScheduledEventOpen && countdownSeconds > 0 && !addEventModalOpen && (
              <div className="modal-opening-indicator">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div className="spinner"></div>
                  <span>
                    Opening Add Event modal in {countdownSeconds} second
                    {countdownSeconds !== 1 ? 's' : ''}...
                  </span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill"></div>
                </div>
                <div style={{ marginTop: '8px', fontSize: '0.9em', opacity: 0.9 }}>
                  Voice Assistant will remain active for additional data entry
                </div>
              </div>
            )}

            {/* Event created indicator - only show briefly when countdown reaches 0 AND modal has been opened */}
            {/* {hasScheduledEventOpen && countdownSeconds === 0 && eventModalOpened && (
              <div className="message ai-message">
                <div className="avatar">
                  <Avatar sx={{ bgcolor: '#4caf50', color: '#fff' }}>✓</Avatar>
                </div>
                <div
                  className="message-content"
                  style={{ backgroundColor: '#4caf50', color: 'white' }}>
                  Event modal opened! You can continue using voice input to add more details like
                  caller information, notes, etc.
                </div>
              </div>
            )} */}
          </div>

          {/* Microphone button */}
          <div style={{ textAlign: 'center', marginTop: '16px', marginBottom: '16px' }}>
            <div className="mic-container">
              <Button
                onClick={isListening ? stopListening : startListening}
                disabled={connectionStatus === 'connecting'}
                style={{
                  width: '4rem',
                  height: '4rem',
                  borderRadius: '50%',
                  backgroundColor: isListening
                    ? 'red'
                    : connectionStatus === 'connecting'
                    ? '#ccc'
                    : '#0084ff',
                  color: 'white',
                  zIndex: 1,
                }}>
                {connectionStatus === 'connecting' ? (
                  <CircularProgress size={24} color="inherit" />
                ) : isListening ? (
                  <MicOffIcon style={{ fontSize: '1.5rem' }} />
                ) : (
                  <MicIcon style={{ fontSize: '1.5rem' }} />
                )}
              </Button>
              {isListening && <div className="wave-effect" />}
            </div>
            <p style={{ marginTop: '0.5rem', color: '#666', fontSize: '0.8rem' }}>
              {connectionStatus === 'connecting'
                ? 'Connecting...'
                : isListening
                ? 'Tap to stop'
                : 'Tap to speak'}
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VoiceInputModal;
